export enum EXPORT_STATUS_ENUM {
  DONE = 'DONE',
  FAILED = 'ERROR',
  PENDING = 'PENDING',
}

export enum EXPORT_TYPE_ENUM {
  INVOICE = 'invoice',
  TRACKING = 'tracking-page',
  SHIPPING = 'delivery',
}
